// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { productListFilterAccordionSectionStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import AddOutline from "@eisinc/XDL/Icons/AddOutline";
import IconPlpFilterDown from "@eisinc/XDL/Icons/IconPlpFilterDown";
import IconPlpFilterUp from "@eisinc/XDL/Icons/IconPlpFilterUp";
import Minus from "@eisinc/XDL/Icons/Minus";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, styledScrollbar } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
            width: 100%;
            &:not(:last-child) {
                margin-bottom: 10px;
            }
        `,
};
productListFilterAccordionSectionStyles.checkBox = {
    sizeVariant: "small",
    css: css`
        width: 100%;
        span[role="checkbox"] {
            margin: 0;
        }
    `,
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
        css: css`
            word-break: break-all;
            display: flex;
            width: 100%;
        `,
    },
};


productListFilterAccordionSectionStyles.facetName = {
    css: css`
        word-break: keep-all;
        margin-right: 6px;
        flex: 1;
    `,
};

productListFilterAccordionSectionStyles.facetCount = {
    css: css`
        margin-left: auto;
    `,
};


productListFilterAccordionSectionStyles.scrollableContainer = {
    css: css`
        padding-right: 8px;
        line-height: ${fontConfig.singleLinexSmall.lineHeight};
        ${({ scrollable, limitNumber }: any) => {
            if (scrollable) {
                return css`
                    max-height: calc(${limitNumber * 24}px - 8px);
                    ${styledScrollbar(4, "common.ui5")};
                `;
            }
        }}
    `,
};

productListFilterAccordionSectionStyles.accordionSection = {
    mergeCss: true,
    titleTypographyProps: {
        size: fontConfig.singleLinexSmall.size,
        weight: fontConfig.weight.medium,
        css: css`
            line-height: ${fontConfig.singleLinexSmall.lineHeight};
        `,
    },
    headerProps: {
        css: css`
            &&& button,
            &&& button:focus {
                margin-bottom: 0;
                padding: 8px;
                border-bottom: 1px solid ${color("common.border")};
                background: ${color("common.ui2")};
                ${({ expanded }: any) => expanded && "border-bottom: none;"}
                ${IconWrapper}, svg {
                    height: 16px;
                    width: 16px;
                    color: ${color("common.ui6")};
                }
                ${TypographyStyle} {
                    margin-bottom: 0;
                    line-height: ${fontConfig.singleLinexSmall.lineHeight}
                }
            }
        `,
    },
    panelProps: {
        css: css`
            padding: 8px;
            border: none;
            border-bottom: 1px solid ${color("common.border")};
        `,
    },
    expandIconProps: {
        src: IconPlpFilterDown,
        size: 16,
        css: css`
            &,
            svg {
                height: 16px;
                width: 16px;
            }

            &:hover {
                color: ${color("common.ui9")};
            }
        `,
    },
    collapseIconProps: {
        src: IconPlpFilterUp,
        size: 16,
        css: css`
            &,
            svg {
                height: 16px;
                width: 16px;
            }

            &:hover {
                color: ${color("common.ui9")};
            }
        `,
    },
    toggleTransition: {
        positionerCss: css`
            width: 31px;
            height: 16px;
            max-width: 31px;
        `,
    },
    css: css`
        border: 1px solid ${color("common.border")};
    `,
};

productListFilterAccordionSectionStyles.seeAllLink = {
    ...createLinkIconStyles({
        icon: AddOutline,
        sizeVariant: "small",
    }),
};

productListFilterAccordionSectionStyles.seeLessLink = {
    ...createLinkIconStyles({
        icon: Minus,
        sizeVariant: "small",
    }),
};
productListFilterAccordionSectionStyles.section = {
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        & > div {
            padding: 8px;
        }
  `,
};

productListFilterAccordionSectionStyles.title = {
    forwardAs: "p",
    size: fontConfig.singleLinexSmall.size,
    lineHeight: fontConfig.singleLinexSmall.lineHeight,
    css: css`
        background: ${color("common.ui2")};
        padding: 8px;
    `,
};